<template>
    <div class="d-box">
        <div class="cart-box">
            <div class="menu-box">
                <div class="menu-item" @click="onPush('home')">
                    <img src="@/assets/images/icons/home1.png"/>
                </div>
                <div class="menu-item" @click="onPush('cart')">
                    <span class="icon-badge">1</span>
                    <img src="@/assets/images/icons/cart1.png"/>
                </div>
            </div>
            <div class="btn-box">
                <div class="item-btn cart-add" @click="addCart">加入购物车</div>
                <div class="item-btn fast-buy" @click="fastBuy">立即购买</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "CartBtnComponent",
    props: {
   },
    data () {
        return {
        }
    },
    methods: {
        addCart () {
            this.$emit('cart', 'addCart')
        },
        fastBuy () {
            this.$emit('cart', 'fastBuy')
        },
        onPush (routerName) {
            this.$router.push({name: routerName})
        },
        _reset () {
        }
    },
    mounted () {
        this._reset()
    }
}
</script>
<style lang="scss" scoped>
.d-box {
    height: 55px;
}
.cart-box {
    position: fixed;
    width: 100%;
    height: 55px;
    bottom: 0px;
    display: flex;
    flex-direction: row;
    background-color: #ffffff;
    .menu-box {
        width: 36%;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        .menu-item {
            position: relative;
            .icon-badge {
                position: absolute;
                top: -3px;
                left: 55%;
                width: 16px;
                height: 16px;
                background-color: #ffb03f;
                border-radius: 50%;
                color: #ffffff;
                font-size: 12px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
            }
            img {
                width: 28px;
                height: 28px;
            }
        }
    }
    .btn-box {
        width: 64%;
        display: flex;
        flex-direction: row;
        color: #ffffff;
        .item-btn {
            width: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
        }
        .cart-add {
            background-color: #ffb03f;
        }
        .fast-buy {
            background-color: #ff0000;
        }
    }
}
</style>